package com.pincer.core.rules

import com.pincer.core.InvalidData
import com.pincer.core.model.tree.Candidate

class DurationDivisibleByRule(val factor: Int): Rule() {

    override fun score(candidate: Candidate): Float {
        val duration = candidate.duration() ?: return MIGHT_BE_POSSIBLE
        if (duration % factor == 0) return DEFINITELY_POSSIBLE
        return DEFINITELY_NOT_POSSIBLE
    }

    companion object {
        fun parse(params: List<String>): DurationDivisibleByRule {
            if (params.size != 1) throw InvalidData("The durationDivisibleBy rule needs one number parameter")
            try {
                val build = DurationDivisibleByRule(params.first().toInt())
                if (build.factor < 1) throw InvalidData("The number in the duration rule can not be less than one")
                return build
            }
            catch (nfe: NumberFormatException) { throw InvalidData("The number in the duration rule looks wrong") }
        }
    }

}

